import {Fragment, PureComponent} from 'react'
import {connect} from 'react-redux'
import MessageCircle from 'react-feather/dist/icons/message-circle.js'
import Trash from 'react-feather/dist/icons/trash.js'
import Edit from 'react-feather/dist/icons/edit.js'

import CommentsModal from '../../components/Modals/CommentsModal/CommentsModal.jsx'
import Date from '../../../shared/components/Moment/Date.jsx'

import connectModal from '../../../shared/components/Modals/connect.js'
import {isAdmin} from '../../../shared/services/userService.js'

import './Notes.scss'

class Notes extends PureComponent {
  renderNote = (note) => {
    const dates = [{key: 'createdAt', prefix: 'Créé le', value: note.created_at}]
    if (note.updated_at !== note.created_at) {
      dates.push({key: 'updatedAt', prefix: 'Mis à jour le', value: note.updated_at})
    }

    return (
      <li key={note.id} className="d-flex align-items-center">
        <div className="notes-icon">
          <MessageCircle size={12} />
        </div>

        <div className="notes-item bd-gray-200 flex-fill px-4 py-3 radius-lg">
          <div className="d-flex flex-column flex-md-row align-items-md-center">
            <strong>
              {note?.author.firstname ?? ''} {note?.author.lastname ?? ''}
            </strong>

            <time className="ml-0 ml-md-3 mt-1 mt-md-0">
              { dates.map(date => (
                <Fragment key={date.key}>{date.prefix} <Date format="dd/MM/yyyy à HH:mm" date={date.value}/></Fragment>
              )).reduce((prev, curr) => [prev, ' - ', curr]) }
            </time>

            <div className="d-flex align-items-center ml-0 ml-md-auto mt-1 mt-md-0">
              {this.props.onEdit ?
                <div onClick={() => this.props.onEdit(note)} className="btn btn btn-outline-primary btn-round btn-sm flex-shrink-0">
                  <Edit/>
                </div> : ''
              }
              {this.props.isAdmin && this.props.onDelete ?
                <div onClick={() => this.props.onDelete(note.id)} className="btn btn btn-outline-danger btn-round btn-sm ml-2 flex-shrink-0">
                  <Trash/>
                </div> : ''
              }
            </div>
          </div>

          <p className="comment mt-2 mb-0" dangerouslySetInnerHTML={{__html: note.comment}}/>
        </div>
      </li>
    )
  }

  render() {
    const {notes} = this.props

    const children = notes.length === 0 ? (
      <div className="my-5 text-center font-italic">Aucun commentaire</div>
    ) : (
      <ul className="notes">
        { notes.map(note => this.renderNote(note)) }
      </ul>
    )

    return children
  }
}

export default connect(
  (state) => ({
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(connectModal({CommentsModal}, Notes))
